import { IconButton, Menu } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBan, faEllipsisV, faPartyHorn, faPen, faUndo } from "@fortawesome/pro-light-svg-icons"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { useAnchorMenu } from "../../../../../../../shared/hooks/useAnchorMenu"

import { OverflowMenuEntry, OverflowMenuItem } from "../OverflowMenuItem"

const useStyles = makeStyles()((theme) => ({
    button: {
        position: "absolute",
        top: ".375rem",
        right: ".375rem",
        width: "1.375rem",
        height: "1.375rem",
        color: theme.palette.tailwind.slate[400],
        "& svg": {
            fontSize: ".875rem",
        },
        "&:hover": {
            color: theme.palette.text.primary,
        },
    },
}))

type Props = Readonly<{
    hasTheme: boolean
    isClosed: boolean
    onMakeTheme: () => void
    onRenameTheme: () => void
    onRemoveTheme: () => void
    onCloseDay: () => void
    onReopenDay: () => void
}>

export function DayOverflowMenu({
    hasTheme,
    isClosed,
    onMakeTheme,
    onRenameTheme,
    onRemoveTheme,
    onCloseDay,
    onReopenDay,
}: Props) {
    const { classes } = useStyles()
    const { anchorEl, isOpen, open, close, closeThen } = useAnchorMenu()

    const makeThemeEntry: OverflowMenuEntry = {
        labelId: "merchant-week-menu-day-menu-theme-item",
        label: "Make this a theme day",
        icon: faPartyHorn,
        onClick: onMakeTheme,
    }
    const renameThemeEntry: OverflowMenuEntry = {
        labelId: "merchant-week-menu-day-menu-rename-theme-item",
        label: "Rename theme…",
        icon: faPen,
        onClick: onRenameTheme,
    }
    const removeThemeEntry: OverflowMenuEntry = {
        labelId: "merchant-week-menu-day-menu-remove-theme-item",
        label: "Remove theme day",
        icon: faUndo,
        onClick: onRemoveTheme,
    }
    const closedDayEntry: OverflowMenuEntry = isClosed
        ? {
              labelId: "merchant-week-menu-closed-reopen-button",
              label: "Reopen day",
              icon: faUndo,
              onClick: onReopenDay,
          }
        : {
              labelId: "merchant-week-menu-day-menu-close-item",
              label: "Mark day as closed",
              icon: faBan,
              onClick: onCloseDay,
          }

    const entries: ReadonlyArray<OverflowMenuEntry> = [
        ...(!hasTheme && !isClosed ? [makeThemeEntry] : []),
        ...(hasTheme ? [renameThemeEntry, removeThemeEntry] : []),
        closedDayEntry,
    ]

    return (
        <>
            <LocalizedStrict id="merchant-week-menu-day-menu-button" attrs={{ "aria-label": true }}>
                <IconButton size="small" aria-label="Day actions" className={classes.button} onClick={open}>
                    <FontAwesomeIcon icon={faEllipsisV} />
                </IconButton>
            </LocalizedStrict>
            <Menu open={isOpen} anchorEl={anchorEl} onClose={close}>
                {entries.map((entry) => (
                    <OverflowMenuItem key={entry.labelId} entry={entry} onClick={closeThen(entry.onClick)} />
                ))}
            </Menu>
        </>
    )
}
